import { h } from '@stencil/core';
import { EQdsButtonImportance, EQdsButtonSize, getQdsIconLibrary } from '@pes-ui/utils';
export class FavoritesButton {
  constructor() {
    this.addLabel = undefined;
    this.removeLabel = undefined;
    this.addIcon = "star";
    this.removeIcon = "star-on";
    this.isInList = false;
    this.qdsButtonRenderCount = 0;
    this.el.dir = document.documentElement.dir || 'auto';
  }
  onIsInListChange(newValue) {
    this.isInList = newValue;
    ++this.qdsButtonRenderCount;
  }
  render() {
    const label = this.isInList ? this.removeLabel : this.addLabel;
    const icon = this.isInList ? this.removeIcon : this.addIcon;
    return (h("qds-button", { key: this.qdsButtonRenderCount, iconName: icon, size: EQdsButtonSize.STANDARD, importance: EQdsButtonImportance.SUBDUED, class: "favorites-button__container", text: label, variant: "hero", iconLibrary: getQdsIconLibrary(icon) }));
  }
  static get is() { return "pes-favorites-button"; }
  static get encapsulation() { return "shadow"; }
  static get originalStyleUrls() {
    return {
      "$": ["favorites-button.scss"]
    };
  }
  static get styleUrls() {
    return {
      "$": ["favorites-button.css"]
    };
  }
  static get properties() {
    return {
      "addLabel": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": true,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "add-label",
        "reflect": false
      },
      "removeLabel": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": true,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "remove-label",
        "reflect": false
      },
      "addIcon": {
        "type": "string",
        "mutable": true,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "add-icon",
        "reflect": false,
        "defaultValue": "EQdsIcons.STAR"
      },
      "removeIcon": {
        "type": "string",
        "mutable": true,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "remove-icon",
        "reflect": false,
        "defaultValue": "EQdsIcons.STAR_FILLED"
      },
      "isInList": {
        "type": "boolean",
        "mutable": true,
        "complexType": {
          "original": "boolean",
          "resolved": "boolean",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "is-in-list",
        "reflect": false,
        "defaultValue": "false"
      }
    };
  }
  static get states() {
    return {
      "qdsButtonRenderCount": {}
    };
  }
  static get elementRef() { return "el"; }
  static get watchers() {
    return [{
        "propName": "isInList",
        "methodName": "onIsInListChange"
      }];
  }
}
